import axios from 'axios';
import { API_URL } from '../../utils/constant';

const authHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`,
});

// ── List (paginated + filterable) ─────────────────────────────────────────────
// params: { page, limit, type, priority, unreadOnly, search }
export const notificationList = async (params = {}) => {
  const response = await axios.get(`${API_URL}/notification/list`, {
    headers: authHeader(),
    params,
  });
  return response.data;
};

// ── Lightweight badge counts only ─────────────────────────────────────────────
export const getNotificationCounts = async () => {
  const res = await axios.get(`${API_URL}/notification/counts`, {
    headers: authHeader(),
  });
  return res.data;
};

// ── Today's business event stats bar ─────────────────────────────────────────
export const getDailyStats = async () => {
  const res = await axios.get(`${API_URL}/notification/daily-stats`, {
    headers: authHeader(),
  });
  return res.data;
};

// ── Mark all as read ──────────────────────────────────────────────────────────
export const viewAllNotification = async () => {
  const res = await axios.post(`${API_URL}/notification/view-notification`, null, {
    headers: authHeader(),
  });
  return res.data;
};

// ── Mark single notification as read ─────────────────────────────────────────
export const markNotificationRead = async (id) => {
  const res = await axios.post(`${API_URL}/notification/view/${id}`, null, {
    headers: authHeader(),
  });
  return res.data;
};

// ── Archive a single notification ─────────────────────────────────────────────
export const archiveNotification = async (id) => {
  const res = await axios.delete(`${API_URL}/notification/archive/${id}`, {
    headers: authHeader(),
  });
  return res.data;
};

// ── Archive all read notifications ────────────────────────────────────────────
export const archiveAllNotifications = async () => {
  const res = await axios.post(`${API_URL}/notification/archive-all`, null, {
    headers: authHeader(),
  });
  return res.data;
};

// ── Legacy: permanently delete all read notifications ────────────────────────
export const clearAllNotifications = async () => {
  const res = await axios.delete(`${API_URL}/notification/clear`, {
    headers: authHeader(),
  });
  return res.data;
};
